import { TreePalm, MapPin, Phone, Mail } from "lucide-react";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1A1C18] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-[#2F5233] rounded-full flex items-center justify-center">
                <TreePalm className="w-6 h-6 text-white" />
              </div>
              <span
                className="font-bold text-xl"
                style={{ fontFamily: "'Fraunces', serif" }}
              >
                Kishan Coconut Nursery
              </span>
            </div>
            <p className="text-white/60 leading-relaxed mb-6 max-w-md">
              Producing quality hybrid coconut seedlings following
              recommended nursery management practices. NHB Registered & CPCRI
              Trained.
            </p>
            <div className="flex items-center gap-2 text-[#E07A5F]">
              <span className="text-sm font-medium">
                ASM Udhyan Ratna Award 2024 Recipient
              </span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-6 text-lg">Quick Links</h4>
            <ul className="space-y-3">
              {["Home", "About", "Products", "Infrastructure", "Awards", "Contact"].map(
                (link) => (
                  <li key={link}>
                    <a
                      href={`#${link.toLowerCase()}`}
                      className="text-white/60 hover:text-white transition-colors"
                    >
                      {link}
                    </a>
                  </li>
                )
              )}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-6 text-lg">Contact Info</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#E07A5F] flex-shrink-0 mt-0.5" />
                <span className="text-white/60 text-sm">
                  Village Supasi, Taluka Veraval<br />
                  District Gir Somnath – 362255<br />
                  Gujarat, India
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-[#E07A5F]" />
                <a
                  href="tel:9825911774"
                  className="text-white/60 hover:text-white transition-colors text-sm"
                >
                  98259 11774
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 mt-12 pt-8">
          {/* Disclaimer */}
          <div className="bg-white/5 p-6 rounded-2xl mb-8">
            <h5 className="font-semibold text-[#E07A5F] mb-2">Disclaimer</h5>
            <p className="text-white/50 text-sm leading-relaxed">
              This nursery name, website content, and photographs are the
              property of Kishan Coconut Nursery. No individual or nursery is
              authorized to use the nursery name, content, or photographs
              without written permission from the proprietor.
            </p>
          </div>

          {/* Copyright */}
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/40 text-sm">
              © {currentYear} Kishan Coconut Nursery. All rights reserved.
            </p>
            <p className="text-white/40 text-sm">
              Proprietor: Solanki Mandabhai Hamirbhai
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
